import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_FR.json';
import audios from './LOVE_AUDIOS_FR.json';

export const LOVE_DATA_FR: ServiceData = {
  articles,
  audios,
};
